import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Col, Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import ProcessingAgencyModal from '../../../containers/masters/ProcessingAgency/ProcessingAgencyModalPage'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import InputTreeSelect from '../../commons/form/InputTreeSelect'
import ModalMassUploadPage from '../../../containers/masters/ModalMassUpload/ModalMassUploadPage'
import { loadTemplatesNames, permissions } from '../../../constants/backendIds'
import { getFieldsSectionPermissions } from '../../../util/permisionFunctions'
import ProcessingAngencyUsersModalPage from '../../../containers/masters/ProcessingAgency/ProcessingAngencyUsersModalPage'
import ProcessingAgencyIntegrationModal from '../../../containers/masters/ProcessingAgency/ProcessingAgencyIntegrationModalPage'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class ProcessingAgency extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchUO: null,
        searchName: null
      },
      showModal: false,
      fieldsConfiguration: {
        loadDataTemplate: null
      }
    }
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchProcessingAgencyList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchProcessingAgencyList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleOrganizedUnitChange (searchUO) {
    if (!searchUO || searchUO.length === 0) {
      this.setState({ filter: { ...this.state.filter, searchUO: [] } })
      return
    }
    const searchUoList = searchUO.split(',').map((item) => {
      return parseInt(item)
    })
    if (this.state.filter.searchUO !== searchUoList) {
      this.setState({ filter: { ...this.state.filter, searchUO: searchUoList } })
    }
  }

  handleNameChange (searchName) {
    if (this.state.filter.searchName !== searchName) {
      this.setState({ filter: { ...this.state.filter, searchName } })
    }
  }

  searchProcessingAgency () {
    this.props.actions.fetchProcessingAgencyList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  openProcAgModalLoad () {
    this.setState({ showModal: true })
    this.props.actions.openModalMass('MASTERS.PROCESSING_AGENCY_MASTERS.MODAL_UPLOAD.', this.props.actions.uploadProcAgMassDocument, this.props.actions.fetchProcessingAgencyList)
  }

  closeProcAgModalLoad () {
    this.setState({ showModal: false })
  }

  componentDidMount () {
    this.props.actions.fetchProcessingAgencyCommunicationServices()
    this.props.actions.fetchProcessingAgencyList()
  }

  componentDidUpdate (prevProps) {
    if (this.props.tabConfiguration !== prevProps.tabConfiguration) {
      if (this.props.tabConfiguration && this.props.tabConfiguration.sectionFieldsConfiguration) {
        const fieldKeys = Object.keys(this.state.fieldsConfiguration)
        const permission = getFieldsSectionPermissions(this.props.tabConfiguration.sectionFieldsConfiguration, fieldKeys, permissions.hidden)
        this.setState({ fieldsConfiguration: permission.fieldsConfiguration })
      }
    }
  }

  resetFilters () {
    this.setState({
      filter: {
        searchUO: null,
        searchName: null
      }
    }, () => { this.searchProcessingAgency() })
  }

  render () {
    const {
      t, agencyList, pagesCount, agenciesCount, filter,
      filter: { page },
      combos: { UOTreeCombo },
      actions: { openEditProcessingAgencyModal, openAddProcessingAgencyModal, fetchProcessingAgencyList, deleteProcessingAgency, fetchTemplateFile, recoverProcessingAgency, openUserProcessingAgencyModal, showEditProcessingAgencyIntegrationModal }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'processingAgency' })
    const tKey = 'MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const userTooltip = (<Tooltip id="editTooltip">{t(`${tKey}USERS`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const recoverTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}RECOVER`)}</Tooltip>)
    const hasFilters = (this.state.filter.searchUO || this.state.filter.searchName)
    const editIntegrationTooltip = (<Tooltip id="editIntegrationTooltip">{t(`${tKey}EDIT_INTEGRATION`)}</Tooltip>)
    const downloadTemplateTooltip = (<Tooltip id="userTooltip">{t('MASTERS.DOWNLOAD')}</Tooltip>)

    return (
      <div id="processingAgencyMaster" className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openAddProcessingAgencyModal()}>
              <i className='iDocIcon-add-plus'></i>{t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
            </Button>
            {this.state.fieldsConfiguration.loadDataTemplate && this.state.fieldsConfiguration.loadDataTemplate.permission > permissions.hidden &&
              <OverlayTrigger placement="left" overlay={downloadTemplateTooltip}>
                <Button
                  className="_Btn accent o-icn"
                  onClick={() => fetchTemplateFile(loadTemplatesNames.procAg)}
                  onKeyDown={(e) => handleKeyDown(e)}
                >
                  <i className='iDocIcon-download'></i>
                </Button>
              </OverlayTrigger>
            }
            {this.state.fieldsConfiguration.loadDataTemplate && this.state.fieldsConfiguration.loadDataTemplate.permission > permissions.hidden &&
              <OverlayTrigger placement="left" overlay={<Tooltip id="editProductTooltip">{' ' + t('ADMIN.RECURRENT_ENTITIES.MODAL_MASS_UPLOAD.UPLOAD_DOCUMENT')}</Tooltip>}>
                <Button
                  className="_Btn new o-icn"
                  onClick={this.openProcAgModalLoad.bind(this)}
                >
                  <i className='iDocIcon-file-excel' />
                </Button>
              </OverlayTrigger>
            }

          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputTreeSelect}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="filters.organizedUnit"
                controlLabel={t(`${tKey}PROCESSING_AGENCY_MASTERS.ORGANIZED_UNIT`)}
                placeholder={t(`${tKey}PROCESSING_AGENCY_MASTERS.ORGANIZED_UNIT`)}
                multi={true}
                valueKey="value"
                labelKey="label"
                childrenKey="children"
                options={UOTreeCombo}
                onInputChange={(value) => this.handleOrganizedUnitChange(value)}
              />
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="filters.name"
                controlLabel={t(`${tKey}PROCESSING_AGENCY_MASTERS.NAME`)}
                placeholder={t(`${tKey}PROCESSING_AGENCY_MASTERS.NAME`)}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchProcessingAgency()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              <Table className="editable-table" hover responsive>
                <thead>
                  <tr>
                    <th onClick={() => { this.changeOrder('code') }}>
                      {t(`${tKey}PROCESSING_AGENCY_MASTERS.ORGANIZED_UNIT`)}
                      <i className={this.getSortIcon('code')} />
                    </th>
                    <th onClick={() => { this.changeOrder('name') }}>
                      {t(`${tKey}PROCESSING_AGENCY_MASTERS.NAME`)}
                      <i className={this.getSortIcon('name')} />
                    </th>
                    <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                  </tr>
                </thead>
                <tbody>
                  {agencyList && agencyList.map((agency, idx) => {
                    return (
                      <tr key={idx} className={(agency.isDeleted ? 'is-deleted' : '')}>
                        <td>{agency.organizedUnitName}</td>
                        <td>{agency.name}</td>
                        <td className='actions'>
                          {!agency.isDeleted ? (
                            <div>
                              <OverlayTrigger placement="left" overlay={editIntegrationTooltip}>
                                <a className="_Btn accept stk o-icn " onClick={() => showEditProcessingAgencyIntegrationModal(true, agency.processingAgencyId)}>
                                  <i className="iDocIcon-Organizational-Unit" />
                                </a>
                              </OverlayTrigger>
                              <OverlayTrigger placement="left" overlay={editTooltip}>
                                <a className='_Btn accept stk o-icn ' onClick={() => openEditProcessingAgencyModal(agency.processingAgencyId)}>
                                  <i className="iDocIcon-edit" />
                                </a>
                              </OverlayTrigger>
                              <OverlayTrigger placement="left" overlay={userTooltip}>
                                <a className='_Btn accept stk o-icn ' onClick={() => openUserProcessingAgencyModal(agency)}>
                                  <i className="iDocIcon-user-no-image-user-menu" />
                                </a>
                              </OverlayTrigger>
                              <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                <a className='_Btn cancel stk o-icn ' onClick={() => deleteProcessingAgency(agency.processingAgencyId)}>
                                  <i className="iDocIcon-delete-forever" />
                                </a>
                              </OverlayTrigger>

                            </div>
                          ) : (
                            <div>
                              <OverlayTrigger placement="left" overlay={recoverTooltip}>
                                <a className='_Btn accent stk o-icn ' onClick={() => recoverProcessingAgency(agency.processingAgencyId)}>
                                  <i className='iDocIcon-undo-back' />
                                </a>
                              </OverlayTrigger>
                            </div>
                          )}
                        </td>
                      </tr>)
                  })
                  }

                </tbody>
              </Table>
              {(agencyList === null || agencyList === undefined || agencyList.length === 0) &&
                <p className="no_results" >{t(`${tKey}PROCESSING_AGENCY_MASTERS.RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={agenciesCount}
                    onSelectAction={(value) => fetchProcessingAgencyList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div className="admin-wrapper">

          <Col sm={12} className="col-row  section-users-body">

          </Col>
        </div>
        <ModalMassUploadPage showModal={this.state.showModal} closeModal={this.closeProcAgModalLoad.bind(this)}/>
        <ProcessingAgencyModal />
        <ProcessingAgencyIntegrationModal />
        <ProcessingAngencyUsersModalPage fetchProcessingAgencyList={() => this.props.actions.fetchProcessingAgencyList({ ...this.props.filter, ...this.state.filter })}></ProcessingAngencyUsersModalPage>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listAgencies'
})(ProcessingAgency)
